import { Component, AfterContentInit, OnDestroy, ElementRef } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { SessionDTO } from '../../api/plyca-dtos-v2';
import { PaginationDTO } from '../../api/PaginationModel';
import { UserService } from '../../user.service';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { BaseComponent } from '../../components/common/baseComponent/base.component';

@Component({
  selector: 'sessionsPanel',
  templateUrl: 'sessionsPanel.template.html'
})
export class sessionsPanelComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  loaded = false;
  sessions: SessionDTO[] = [];
  constructor(
    public plycaService: PlycaDataService,
    public uiService: UIService,
    public helpService: HelpService,
    public userService: UserService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef
  ) {
    super()
    this.subscribe(this.helpService.showContextHelpObservable([HelpType.SESIONS]));
  }

  ngAfterContentInit(): void {


    this.headerActionsService.setTaskDescription(this.elem, 'Sessions.activeSessions', 'fas fa-sign-in-alt', this.isLoaded.bind(this));
    this.subscribe(this.headerActionsService.addAction(
      'General.reload',
      'fas fa-sync-alt',
      'btn-secondary',
      true
    ), success => {
      this.loadSessions();
    });
    this.headerActionsService.addDivider();

    this.subscribe(this.headerActionsService.addAction(
      'General.back',
      'fas fa-chevron-left',
      'btn-outline-secondary',
      true
    ), success => {
      this.uiService.routeBack();
    });


    this.loadSessions();
  }

  ngOnDestroy() {
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  loadSessions() {
    this.loaded = false;
    this.subscribe(this.plycaService.getSessions(),
      (result: PaginationDTO<SessionDTO>) => {
        if (result && result.content) {
          this.sessions = result.content;
        } else {
          this.sessions = [];
        }
        this.loaded = true;
      });
  }

  invalidateSession(session: SessionDTO) {
    this.loaded = false;
    this.subscribe(this.plycaService
      .invalidateSession(this.userService.getUserId(), session),
      () => {
        setTimeout(() => {
          this.loadSessions();
        }, 500);
      });
  }
}
